import { ImageProps } from "@omni/types/components/props/image.props";
import { Image } from "@omni/ui/components/Image/image";

import { card } from "../../card.style";
import { useCardContext } from "../../context/card.context";

export type CardImageProps = ImageProps;

const CardImage = ({ className, ...attributes }: CardImageProps) => {
    const { imgAlignment, border } = useCardContext();

    const { image } = card({ imgAlignment, border });

    return (
        <Image
            {...attributes}
            className={image({ className })}
        >
            <Image.Img />
        </Image>
    );
};

export { CardImage };
